import { Routes } from "./routes";
import { ChakraProvider, CSSReset } from "@chakra-ui/react";
import { theme } from "./styles/theme";
import { AuthProvider } from "./context/AuthContext";
import { ThemeModeProvider } from "./context/ThemeModeContext";
import { SidebarProvider } from "./context/SidebarContext";
import { AssistenteProvider } from "./context/AssistenteContext";
import "./styles/style.css";
import "./styles/light-theme.css";
// import "./estilo.css";

export function App() {
  return (
    <>
      <ChakraProvider theme={theme}>
        <CSSReset />
        <ThemeModeProvider>
          <AuthProvider>
            <SidebarProvider>
              {/* A conversa do assistente, comum ao balão e à página. */}
              <AssistenteProvider>
                <Routes />
              </AssistenteProvider>
            </SidebarProvider>
          </AuthProvider>
        </ThemeModeProvider>
      </ChakraProvider>
    </>
  );
}
